angular.module("EICDataStream3.GeographicalSummary",
    [
        // "EICDataStream3.Authorization",
        'EICDataStream3.config',
        "EICDataStream3.domUtilities",
        'ngStorage',
        "ivpusic.cookie",
        "EICDataStream3.userData"
    ]) //
    //.config([
    //    '$httpProvider',
    //    function($httpProvider) {
    //        // $httpProvider.interceptors.push('oidcHttpInterceptor');
    //    }
    //])
    .controller("GeographicalSummaryController",
        [
            '$scope', "geographicalSummaryData", "userAccessService", "APP_META",
            function ($scope, geographicalSummaryData, userAccessService, APP_META) {
                $scope.isDevelopment = (APP_META.environment.name === "development");

                $scope.geographicalSummaryData = geographicalSummaryData;

                $scope.projectLinks = [];

                var sectorVisibility = function (sectorId) {
                    if (!$scope.access) return false;

                    if ($scope.access.accessType === 'industry' || $scope.access.accessType === 'hybrid') {
                        return ($scope.access.allowedSectors.indexOf(sectorId) !== -1);
                    } else {
                        return true;
                    }

                    //return ($scope.access.accessType !== 'industry' ||
                    //    $scope.access.allowedSectors.indexOf(sectorId) !== -1);
                };


                // Just  extend this
                // Major changes are coming so  it is not worth the depth of change
                // needed to  make the switch to calling bc for the energy sectors
                $scope.energySectors = {
                    listItems: [
                        {
                            text: "Upstream",
                            value: 1,
                            visible: sectorVisibility
                        },
                        {
                            text: "Midstream",
                            value: 7,
                            visible: sectorVisibility
                        },
                        {
                            text: "Downstream",
                            value: 2,
                            visible: sectorVisibility
                        },
                        {
                            text: "Power",
                            value: 3,
                            visible: sectorVisibility
                        },
                        {
                            text: "Renewables",
                            value: 6,
                            visible: sectorVisibility
                        },
                        {
                            text: "Hydrogen",
                            value: 9,
                            visible: sectorVisibility
                        },
                        {
                            text: "CCS",
                            value: 10,
                            visible: sectorVisibility
                        },
                        {
                            text: "Energy Storage",
                            value: 11,
                            visible: sectorVisibility
                        },
                        {
                            text: "Transmission & Distribution",
                            value: 8,
                            visible: sectorVisibility
                        }
                    ],
                    selected: 0,

                    names: [
                        "undefined", //  0
                        "Upstream", //  1
                        "Downstream", //  2
                        "Power", //  3
                        "undefined", //  4
                        "undefined", //  5
                        "Renewables", //  6
                        "Midstream", //  7
                        "Transmission & Distribution", //  8
                        "Hydrogen", //  9
                        "CCS", // 10
                        "Energy Storage" // 11
                    ]
                };


                $scope.chartTypes = {
                    listItems: [
                        {
                            text: "Capex",
                            value: 0,
                            caption: "Estimated CAPEX"
                        },
                        {
                            text: "Capacity",
                            value: 1,
                            caption: "New Generating Capacity"
                        }
                    ],
                    selected: "0",

                    names: [
                        "Estimated CAPEX", // 0
                        "New Generating Capacity" // 1
                    ]
                };

                $scope.isProjectVisible = function (projectLink) {
                    if ($scope.projectListFilter.active) {
                        return (projectLink.startUp === $scope.projectListFilter.startupYear) &&
                            (projectLink.projectStage.replace(" ", "").replace("-", "") ===
                                $scope.projectListFilter.projectStage);
                    } else {
                        return true;
                    }

                };

                $scope.resetProjectListFilter = function () {
                    $scope.projectListFilter = {
                        active: false,
                        startupYear: 0,
                        projectStage: "",
                        caption: "Unfiltered"
                    };
                };

                $scope.projectListFilter = {
                    active: false,
                    startupYear: 0,
                    projectStage: "",
                    caption: "Unfiltered"
                };

                $scope.onBarClicked = function (d, i) {
                    $scope.projectListFilter.active = true;
                    $scope.projectListFilter.startupYear = d.startupYear;
                    $scope.projectListFilter.projectStage = d.key;
                    $scope.projectListFilter.caption = "Filtered (" + d.key + ", " + d.startupYear + ")";

                    scope.$applyAsync(); // Will trigger a digest soon, batching multiple calls if needed
                    //$scope.$apply();
                };


                userAccessService.getRights()
                    .then(function (response) {
                        $scope.access = response.data;
                    });


                $scope.selectProject = function (project) {
                    var winId = window.open(
                        '/search/project/' + project.projectId + '/' + project.projectName.urlEncode(), // + '/',
                        'SimpleProjectView',
                        'width=800,height=800,resizable=yes,scrollbars=yes,toolbar=no,location=no,directories=no,status=no,menubar=no,copyhistory=no');
                    winId.focus();
                };

                $scope.clearTable = function () {
                    console.log("GeographicalSummaryController:clearTable");

                    // $scope.$apply(function () {
                    //     $scope.projectLinks = [];
                    // });

                    $scope.$applyAsync(function () {
                        $scope.projectLinks = [];
                    });


                };

                $scope.isChartVisible = function () {
                    return $scope.energySectors.selected && $scope.countrySelected;
                };

                $scope.sortSpec = {
                    field: "projectName",
                    direction: "asc",

                    projectName: {
                        defaultDirection: "asc"
                    },
                    projectType: {
                        defaultDirection: "asc"
                    },
                    value: {
                        defaultDirection: "desc"
                    }
                };


                function doCompare(a, b, field) {
                    if (a[field] < b[field])
                        return -1;
                    if (a[field] > b[field])
                        return 1;
                    return 0;
                }

                function ascending(field) {
                    return function compare(a, b) {
                        return doCompare(a, b, field);
                    };
                }

                function descending(field) {
                    return function compare(a, b) {
                        return doCompare(b, a, field);
                    };
                }


                $scope.sort = function (column) {
                    if ($scope.sortSpec.field !== column) {
                        $scope.sortSpec.field = column;

                        // invert the default sort order so that the toggle will put 
                        // it back to the correct default
                        var inversDefaultDirection = $scope.sortSpec[column].defaultDirection === "asc"
                            ? "desc"
                            : "asc";

                        $scope.sortSpec.direction = inversDefaultDirection;
                    }

                    if ($scope.sortSpec.direction === "asc") {
                        $scope.sortSpec.direction = "desc";
                        $scope.projectLinks = $scope.projectLinks.sort(descending(column));
                    } else {
                        $scope.sortSpec.direction = "asc";
                        $scope.projectLinks = $scope.projectLinks.sort(ascending(column));
                    }
                };


                var onTokenExpired = function (e) {
                    console.log("GeographicalSummaryController:onTokenExpired");
                    console.log(e);
                };
                $scope.$on('tokenExpired', onTokenExpired);

                var onUnauthorised = function (e) {
                    console.log("GeographicalSummaryController:onUnauthorised");
                };
                $scope.$on('unauthorized', onUnauthorised);


                var margins = {
                    left: 80,
                    right: 80,
                    top: 70,
                    bottom: 60
                };

                var canvas = {
                    height: 400,
                    width: 400
                };

                var chart = {
                    height: canvas.height - margins.top - margins.bottom,
                    width: canvas.width - margins.left - margins.right
                };

                var captionBase = {
                    capex: {
                        axes: {
                            x: "Startup Year",
                            y: "Estimated CAPEX $(million)"
                        },
                        title: ": Estimated CAPEX by Startup Year",
                        tooltipTemplate:
                            "Startup Year: <~startupYear~><br>Stage: <~key~><br>Est.CAPEX: $<~value~> M<br><div class='clickMsg'>Click to filter projects</div>"
                    },
                    capacity: {
                        axes: {
                            x: "Startup Year",
                            y: "New Generating Capacity (MW)"
                        },
                        title: ": New Generating Capacity by Startup Year",
                        tooltipTemplate:
                            "Startup Year: <~startupYear~><br>Stage: <~key~><br>New Generating Capacity: <~value~> MW<div class='clickMsg'>Click to filter projects</div>"
                    }
                };

                $scope.chartOptions = {
                    chart: chart,
                    canvas: canvas,
                    margins: margins,
                    captions: captionBase.capex
                };


                var setChartCaptions = function (selectedValue) {
                    if (selectedValue === 1) {
                        $scope.chartOptions.captions = captionBase.capacity;
                    } else {
                        $scope.chartOptions.captions = captionBase.capex;
                    }
                };

                $scope.$watch('energySectors.selected',
                    function (newValue, oldValue) {
                        if (!$scope.energySectors.selected) return;

                        console.log("sector selection changed to " + $scope.energySectors.selected);

                        $scope.refreshRegion()
                            .then(function (region) {
                                var currentCountry = geographicalSummaryData.getCurrentCountry();

                                // exit straight away if no country has been selected yet
                                if (!currentCountry) return;

                                var sid = currentCountry.sid;

                                $scope.countryName = currentCountry.name;
                                $scope.countrySummary = region.countrySummariesDictionary[sid].sectorSummary;

                            });

                        $scope.refreshProjects();

                        // reveal the chart selector if the selected sector is power or renewables
                        // the default in theses cases is to show the alternate graph of
                        // new generating capacity vs startup year
                        if (newValue === "3" || newValue === "6") {
                            $scope.showChartTypeSelector = true;
                            $scope.chartTypes.selected = 1;
                        } else {
                            $scope.showChartTypeSelector = false;
                            $scope.chartTypes.selected = 0;
                        }

                        setChartCaptions($scope.chartTypes.selected);
                        $scope.refreshChartData();
                    });


                $scope.$watch('chartTypes.selected',
                    function (newValue, oldValue) {
                        // Awkwardly, we get the number back as a string
                        // This will convert it back into a number
                        $scope.chartTypes.selected = +$scope.chartTypes.selected//, 10;

                        setChartCaptions($scope.chartTypes.selected);
                        $scope.refreshChartData();
                    });


                $scope.refreshChartData = function () {
                    if ($scope.chartTypes.selected === 1) {
                        $scope.refreshStartupYearCapacity();
                    } else {
                        $scope.refreshStartupYearCapex();
                    }
                };

                $scope.refreshProjects = function () {
                    var currentCountry = geographicalSummaryData.getCurrentCountry();

                    if (!currentCountry) return;


                    geographicalSummaryData.getProjectLinks(currentCountry.sid, $scope.energySectors.selected)
                        .then(function (projectLinks) {
                            $scope.projectLinks = ($scope.sortSpec.direction === "desc")
                                ? projectLinks.sort(descending($scope.sortSpec.field))
                                : projectLinks.sort(ascending($scope.sortSpec.field));

                            currentCountry.projectLinks = projectLinks;

                            $scope.onCountryDataReceived(currentCountry);
                            $scope.resetProjectListFilter();

                        });
                };

                //$scope.refreshCountrySummary = function() {
                //  $scope.currentCountry = geographicalSummaryData.getCurrentCountry();

                //  if ($scope.currentCountry) {
                //    $scope.countrySummary = $scope.currentCountry.sectorSummary;
                //  }
                //};


                //---------------------------------------------------------------------------------------
                //  Fetch Data
                //---------------------------------------------------------------------------------------       

                $scope.refreshStartupYearCapex = function () {
                    var currentCountry = geographicalSummaryData.getCurrentCountry();

                    if (!currentCountry) return;

                    $scope.chartData = geographicalSummaryData
                        .getCapexByStartupYear(currentCountry.sid, $scope.energySectors.selected)
                        .catch(function (e) {
                            // do some logging here!
                            console.log(e.status);

                            $scope.chartVisibility = { 'display': 'none' };
                        });
                };


                $scope.refreshStartupYearCapacity = function () {
                    var currentCountry = geographicalSummaryData.getCurrentCountry();

                    if (!currentCountry) return;

                    currentCountry = geographicalSummaryData.getCurrentCountry();
                    $scope.chartData = geographicalSummaryData
                        .getCapacityByStartupYear(currentCountry.sid, $scope.energySectors.selected)
                        .catch(function (e) {
                            // do some logging here!
                            console.log(e.status);

                            $scope.chartVisibility = { 'display': 'none' };
                        });
                };

                //        // /Fetch Data -------------------------------------------------------------------------      

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////


                $scope.displayCountryHeader = function () {
                    var currentCountry = geographicalSummaryData.getCurrentCountry();

                    if (!currentCountry) return false;
                    if (!currentCountry.isAccessible) return false;
                    if ($scope.energySectors.names[$scope.energySectors.selected] === 'undefined') return false;

                    return true;
                };

                $scope.onRegionClicked = function (ev, sid, map) {
                    // if any countries in the current region are inaccessible, displat the upgrade panel
                    if (geographicalSummaryData.anyCountriesInaccessible) {
                        $scope.displayProjects = false;
                        $scope.displayUpgradePanel = true;
                    }
                };

                $scope.onCountryDataReceived = function (countrySummary) {
                    if (!countrySummary.isAccessible) {
                        $scope.displayProjects = false;
                        $scope.displayUpgradePanel = true;
                    }

                    // This is a bit of a dirty hack to correct a 
                    // control-flow/timing issue where this bit can 
                    // over-write the country data if the energy sector 
                    // is changed.
                    // The real solution is a rewrite using the reactive 
                    // pattern to keep the state under control with one 
                    // source of model-truth
                    if (!$scope.countrySummary || $scope.countryName !== countrySummary.name) {
                        $scope.countrySummary = countrySummary.sectorSummary;
                        $scope.countryName = countrySummary.name;
                    }


                    $scope.countrySelected = true;
                };

                $scope.onRegionDataReceived = function (regionData) {
                    if (regionData.anyCountriesInaccessible) {
                        $scope.displayProjects = false;
                        $scope.displayUpgradePanel = true;
                    }
                    $scope.countrySelected = false;
                };


                $scope.onCountryClicked = function (ev, sid, map) {
                    if (geographicalSummaryData.getCountry(sid).isAccessible) {
                        geographicalSummaryData.setCurrentCountry(sid);
                        $scope.displayProjects = true;
                        $scope.displayUpgradePanel = false;

                        $scope.refreshProjects();
                        $scope.refreshChartData();
                    } else {
                        // show some sort of message
                        $scope.displayProjects = false;
                        $scope.displayUpgradePanel = true;
                    }

                };


                $scope.mapBackButtonClicked = function (e, a, b, c) {
                    $scope.clearTable();

                    geographicalSummaryData.clearCurrentCountry();
                    $scope.countrySelected = false;

                    $scope.$apply();
                };

                console.log("GeographicalSummaryController:initialised");

            }
        ])
    .service("geographicalSummaryData",
        [
            "$rootScope", "$http", function ($rootScope, $http) {
                var service = this;


                service.currentRegion = "";
                var currentCountry = null;


                service.getRegionData = function (sid, energySector) {
                    return $http.get("/api/GeographicalSummaryRegions",
                        { params: { sid: sid, energySector: energySector } })
                        .then(function (response) {
                            response.data.countrySummariesDictionary = {};
                            response.data.anyCountriesInaccessible = false;

                            response.data.countrySummaries.forEach(function (countrySummary) {

                                if (!countrySummary.isAccessible) response.data.anyCountriesInaccessible = true;

                                response.data.countrySummariesDictionary[countrySummary.sid] = countrySummary;
                            });

                            service.regionData = response.data;

                            return response.data;
                        });
                };


                service.getProjectLinks = function (sid, energySector) {
                    return $http.get("/api/geographicalsummary/projectlinks",
                        { params: { sid: sid, energySector: energySector } })
                        .then(function (response) {
                            return response.data;
                        });
                };
                service.getCapexByStartupYear = function (sid, energySector) {
                    return $http.get("/api/countrystartupyearcapex",
                        { params: { sid: sid, energySector: energySector } })
                        .then(function (response) {
                            return response.data;
                        });
                };

                service.getCapacityByStartupYear = function (sid, energySector) {
                    return $http.get("/api/countrystartupyearcapacity",
                        { params: { sid: sid, energySector: energySector } })
                        .then(function (response) {
                            return response.data;
                        });
                };
                service.getCountry = function (sid) {
                    return service.regionData.countrySummariesDictionary[sid];
                }

                service.getCurrentCountry = function () {
                    return currentCountry;
                }

                service.setCurrentCountry = function (sid) {
                    if (!service.regionData.countrySummariesDictionary) return;
                    currentCountry = service.regionData.countrySummariesDictionary[sid];

                    service.notify();
                };

                service.clearCurrentCountry = function () {
                    currentCountry = null;
                };

                service.subscribe = function (scope, callback) {
                    var handler = $rootScope.$on('notifying-service-event', callback);
                    scope.$on('$destroy', handler);
                };

                service.notify = function () {
                    $rootScope.$emit('notifying-service-event');
                };

            }
        ])
    .directive("geographicalSummary",
        [
            function () {
                return {
                    restrict: 'E',
                    scope: true,
                    controller: "GeographicalSummaryController",
                    templateUrl: '/app-ds3/geographicalSummary/geographicalSummary.partial.html'
                }
            }])
    .directive('html5Map',
        [
            '$q', '$timeout', 'geographicalSummaryData',
            function ($q, $timeout, geographicalSummaryData) {
                return {
                    restrict: 'E',
                    replace: true,
                    template: '<div id="map_container"></div>',
                    link: function (scope, element, attrs) {

                        var map = new FlaMap(map_cfg);
                        scope.map = map;

                        // scope.$apply(function () {
                        //                            map.draw('map_container');
                        // });


                        $timeout(function () {
                            map.draw('map_container');
                        }, 1000)
                        // scope.$apply();

                        // // experiment = use a raw javascript setTimeout
                        // setTimeout(function () {
                        //     map.draw('map_container');
                        // }, 2000);


                        scope.onDevRegionSelected = function () {
                            const sid = scope.regionSelected;

                            geographicalSummaryData.currentRegion = sid;
                            geographicalSummaryData.clearCurrentCountry();
                            scope.projectLinks = [];

                            scope.refreshRegion();
                        }

                        scope.onDevCountrySelected = function () {
                            const sid = scope.countrySelected;

                            if (geographicalSummaryData.getCountry(sid).isAccessible) {
                                geographicalSummaryData.setCurrentCountry(sid);
                                scope.displayProjects = true;
                                scope.displayUpgradePanel = false;

                                scope.refreshProjects();
                                scope.refreshChartData();
                            } else {
                                // show some sort of message
                                $scope.displayProjects = false;
                                $scope.displayUpgradePanel = true;
                            }
                        }

                        scope.refreshRegion = function () {
                            // if no region has been selected, reject the promise to return properly 
                            if (!geographicalSummaryData.currentRegion) return $q.reject();

                            if (geographicalSummaryData.getCurrentCountry())
                                map.unselectState(geographicalSummaryData.getCurrentCountry().sid);

                            console.log("refreshing region data");

                            //return the regiondata as a promise
                            return geographicalSummaryData.getRegionData(geographicalSummaryData.currentRegion,
                                scope.energySectors.selected)
                                .then(function (region) {

                                    region.countrySummaries.forEach(function (countrySummary) {
                                        var i = countrySummary.popup.indexOf("<div style='margin-top:5px'>");

                                        var popup = "";
                                        if (i > -1)
                                            popup = countrySummary.popup.substr(0, i) + "</div>";
                                        else
                                            popup = countrySummary.popup;

                                        map.setStateAttr(countrySummary.sid, 'popup', popup);


                                        if (!countrySummary.isAccessible) {
                                            map.setStateAttr(countrySummary.sid, 'color', "#eeeeee");
                                            map.setStateAttr(countrySummary.sid, 'color2', "#eeeeee");
                                            map.setStateAttr(countrySummary.sid, 'color3', "#eeeeee");
                                        } else if (!countrySummary.count || !scope.energySectors.selected) {
                                            map.setStateAttr(countrySummary.sid, 'color', "#eeeeee");
                                            map.setStateAttr(countrySummary.sid, 'color2', "#eeeeee");
                                            map.setStateAttr(countrySummary.sid, 'color3', "#eeeeee");

                                        } else {
                                            var colourString = computeColourString(region.countrySummaries,
                                                countrySummary);

                                            map.setStateAttr(countrySummary.sid, 'color', colourString);
                                            map.setStateAttr(countrySummary.sid, 'color2', colourString);
                                            map.setStateAttr(countrySummary.sid, 'color3', colourString);
                                        }

                                    });

                                    // scope.onRegionDataReceived(region);

                                    //scope.$apply();
                                    return region;
                                });
                        };


                        function getMaxLogCapex(countrySummaries) {
                            var maxLogCapex = countrySummaries.reduce(function (max, country) {
                                // get capex for all the countries in this region
                                // for the selected sector
                                return Math.max(max, country.sectorSummary.logCapex); //sectorLogCapex
                            },
                                0);

                            return maxLogCapex;
                        };


                        function computeColourString(countrySummaries, countrySummary) {
                            var maxLogCapex = getMaxLogCapex(countrySummaries);

                            var colourScale = 0;
                            var projectCount = 0;

                            colourScale = countrySummary.sectorSummary.logCapex;
                            projectCount = countrySummary.sectorSummary.count;


                            var colourString = "#eeeeee";
                            if (projectCount) {
                                var hue = countrySummary.sectorSummary.hue;
                                colourString = hexValue(colourScale, maxLogCapex, hue);
                            }

                            return colourString;
                        }


                        function hexValue(value, maxValue, hue) {
                            var colourScale = value / maxValue;
                            //var hue = Math.floor((1.0 - colourScale) * 240);

                            return hslToHex(hue, 50, (1.0 - colourScale) * 50 + 50);
                        }


                        function hslToHex(h, s, l) {
                            h /= 360;
                            s /= 100;
                            l /= 100;
                            let r, g, b;
                            if (s === 0) {
                                r = g = b = l; // achromatic
                            } else {
                                const hue2rgb = function (p, q, t) {
                                    if (t < 0) t += 1;
                                    if (t > 1) t -= 1;
                                    if (t < 1 / 6) return p + (q - p) * 6 * t;
                                    if (t < 1 / 2) return q;
                                    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                                    return p;
                                };
                                const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                                const p = 2 * l - q;
                                r = hue2rgb(p, q, h + 1 / 3);
                                g = hue2rgb(p, q, h);
                                b = hue2rgb(p, q, h - 1 / 3);
                            }
                            const toHex = function (x) {
                                const hex = Math.round(x * 255).toString(16);
                                return hex.length === 1 ? '0' + hex : hex;
                            };
                            return "#" + toHex(r).toString() + toHex(g).toString() + toHex(b).toString();
                            //return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
                        }

                        //function hslToHex(h, s, l) {
                        //  h /= 360;
                        //  s /= 100;
                        //  l /= 100;
                        //  let r, g, b;
                        //  if (s === 0) {
                        //    r = g = b = l; // achromatic
                        //  }
                        //  else {
                        //    const hue2rgb = (p, q, t) => {
                        //      if (t < 0) t += 1;
                        //      if (t > 1) t -= 1;
                        //      if (t < 1 / 6) return p + (q - p) * 6 * t;
                        //      if (t < 1 / 2) return q;
                        //      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                        //      return p;
                        //    };
                        //    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                        //    const p = 2 * l - q;
                        //    r = hue2rgb(p, q, h + 1 / 3);
                        //    g = hue2rgb(p, q, h);
                        //    b = hue2rgb(p, q, h - 1 / 3);
                        //  }
                        //  const toHex = x => {
                        //    const hex = Math.round(x * 255).toString(16);
                        //    return hex.length === 1 ? '0' + hex : hex;
                        //  };
                        //  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
                        //}


                        var mapClickHandler = function (ev, sid, map) {
                            var name;
                            // handle region clicks internally, delegate country clicks?
                            if (sid.length === 2) {
                                name = map.fetchStateAttr(sid, 'name');
                                console.log("region: " + name + " entered! (" + sid + ")");

                                geographicalSummaryData.currentRegion = sid;
                                geographicalSummaryData.clearCurrentCountry();
                                scope.projectLinks = [];

                                scope.refreshRegion();

                                scope.onRegionClicked(ev, sid, map);
                            } else {
                                name = map.fetchStateAttr(sid, 'name');
                                console.log("country: " + name + " entered! (" + sid + ")");

                                geographicalSummaryData.setCurrentCountry(sid);

                                scope.onCountryClicked(ev, sid, map);
                            }
                            scope.$applyAsync(); // Will trigger a digest soon, batching multiple calls if needed
                            //scope.$apply();
                        };

                        map.on('click', mapClickHandler);
                    }
                };

            }
        ])
    .directive("mapBackButtonHandler",
        function () {
            function link(scope, element) {
                var backButton = jQuery("button.fm-back-button", "#panelContent");
                backButton.on("click", scope.mapBackButtonClicked);
            };

            return {
                restrict: "AE",
                link: link
            };
        })
    .controller("GeographicalSummaryLoaderController",
        [
            '$scope',
            function ($scope) {
            }
        ]
    )
    .controller("GeographicalSummaryChartController",
        [
            "$scope", "geographicalSummaryData", function ($scope, geographicalSummaryData) {

                console.log("GeographicalSummaryChartController:entered");

                /*
                            Need to  watch for changes on any of these:
                            scope: {
                                energySectors: '=',
                                countrySelected: '=',
                                chartData: '=', // this is  promise 
                                chartType: "=",
                                options: "=",
                                isVisible: "=",
                                onBarClicked: "="
                            },
                */


                var margins = {};
                var canvas = {};
                var chart = {};
                var captions = {};


                var projectStages = {
                    "EPC": { colour: '#a6cee3', label: "EPC" },
                    "IPP": { colour: '#1f78b4', label: "IPP" },
                    "Feasibility": { colour: '#b2df8a', label: "Feasibility" },
                    "ConceptualDesign": { colour: '#33a02c', label: "Conceptual Design" },
                    "Exploration": { colour: '#fb9a99', label: "Exploration" },
                    "FEED": { colour: '#e31a1c', label: "FEED" },
                    "MultiContract": { colour: '#fdbf6f', label: "Multi-Contract" },
                    "PMC": { colour: '#ff7f00', label: "PMC" },
                    "PreFEED": { colour: '#cab2d6', label: "Pre-FEED" },
                    "Term": { colour: '#6a3d9a', label: "Term" },
                    "Consultancy": { colour: '#ffff99', label: "Consultancy" },
                    "EPRD": { colour: '#b15928', label: "EPRD" }
                };


                $scope.$onChanges = function (changesObj) {
                    if (changesObj.chartType) {
                        captions = $scope.options.captions;
                    }

                    if (!$scope.countrySelected) return;

                    $scope.chartData.then(function (data) {
                        $scope.redrawChart(data);
                        $scope.drawLegend({ x: (chart.width + margins.left), y: margins.top }, $scope.color, projectStages);
                    });

                };


                // $scope.$watch('chartType', function (newVal, oldVal) {
                //     if (newVal === oldVal) return; // ignore first run and no-op updates
                //     if (!$scope.countrySelected) return;

                //     $scope.chartData.then(function (data) {
                //         $scope.redrawChart(data);
                //         $scope.drawLegend({ x: (chart.width + margins.left), y: margins.top }, $scope.color, projectStages);
                //     });
                // });


                $scope.parameters = {
                    energySectors: $scope.energySectors,
                    countrySelected: $scope.countrySelected,
                    chartData: $scope.chartData, // this is  promise 
                    chartType: $scope.chartType,
                    options: $scope.options,
                    isVisible: $scope.isVisible,
                    onBarClicked: $scope.onBarClicked
                };

                $scope.$watchGroup(
                    [
                        "energySectors",
                        "countrySelected",
                        "chartData",
                        "chartType",
                        "options",
                        "isVisible",
                        "onBarClicked"
                    ],
                    function (newValues, oldValues, scope) {
                        if (!$scope.countrySelected) return;

                        $scope.chartData.then(function (data) {
                            $scope.redrawChart(data);
                            $scope.drawLegend({ x: (chart.width + margins.left), y: margins.top }, $scope.color, projectStages);

                            scope.$applyAsync(); // Will trigger a digest soon, batching multiple calls if needed
                            //$scope.$apply();
                        });
                    }, true);


                //////////////////////////////////////////////////////////////////////////////////////////////////////////

                $scope.color = d3.scale.ordinal();

                $scope.$onInit = function () {
                    margins = $scope.options.margins;
                    canvas = $scope.options.canvas;
                    chart = $scope.options.chart;
                    captions = $scope.options.captions;

                    $scope.svg = d3.select(".canvas")
                        .attr("width", canvas.width)
                        .attr("height", canvas.height);

                    $scope.chartFrame = $scope.svg.append("g")
                        .attr("y", margins.top)
                        .attr("width", chart.width) // - margin.left - margin.right)
                        .attr("height", chart.height) // - margin.top - margin.bottom)
                        .attr("class", "chart")
                        .append("g")
                        .attr("transform", "translate(" + margins.left + "," + margins.top + ")");


                    $scope.xScale = d3.scale.ordinal()
                        .rangeBands([0, chart.width], .1, .1);

                    $scope.yScale = d3.scale.linear()
                        .range([chart.height, 0])
                        .nice();

                    $scope.xAxisGen = d3.svg.axis().scale($scope.xScale).orient("bottom");
                    $scope.yAxisGen = d3.svg.axis().scale($scope.yScale).orient("left");


                    // X axis
                    $scope.xAxis = $scope.chartFrame.append("g")
                        .attr("transform", "translate(0," + (chart.height) + ")")
                        .attr("class", "x axis");


                    $scope.chartFrame.append("text") // text label for the x axis
                        .attr("x", chart.width / 2)
                        .attr("y", chart.height + margins.top / 2)
                        .attr("class", "axisLabel x")
                        .style("text-anchor", "middle")
                        .text(captions.axes.x);


                    // Y Axis
                    $scope.yAxis = $scope.chartFrame.append("g")
                        .attr("class", "y axis");

                    var yearOffset = [0, 1, 2, 3, 4, 5, 6];
                    var thisYear = (new Date()).getFullYear();
                    var initialYears = yearOffset.map(function (offset) {
                        return thisYear + offset;
                    });

                    $scope.xScale.domain(initialYears);
                    $scope.xAxis.transition().call($scope.xAxisGen);

                    $scope.yScale.domain([0, 10000]);
                    $scope.yAxis.transition().call($scope.yAxisGen);


                    $scope.chartFrame.append("text") // text label for the y axis
                        .attr("transform", "translate(" + (0 - margins.left / 2 - 10) + "," + chart.height / 2 + ")rotate(-90)")
                        .style("text-anchor", "middle")
                        .attr("class", "axisLabel y")
                        .text(captions.axes.y);


                    $scope.svg.append("text") // Country Title
                        .attr("x", canvas.width / 2 + 10)
                        .attr("y", 28)
                        .attr("class", "titleCountry")
                        .style("text-anchor", "middle")
                        .style("font-weight", "bold")
                        .style("font-size", "1.2em");

                    $scope.svg.append("text") // Chart Subtitle
                        .attr("x", canvas.width / 2 + 10)
                        .attr("y", 50)
                        .attr("class", "titleMain")
                        .style("text-anchor", "middle")
                        .style("font-weight", "bold")
                        .style("font-size", "1.0em")
                        .text(captions.title);

                };


                var buildAssociativeArray = function (startupYears) {
                    var projectStagesAssociativeArray = {};
                    startupYears.forEach(function (yearItem) {
                        if (yearItem.projectStages) {
                            yearItem.projectStages.forEach(function (stageItem) {
                                var key = stageItem.projectStage.replace(" ", "").replace("-", "");
                                projectStagesAssociativeArray[key] = 0;
                            });
                        }
                    });

                    return projectStagesAssociativeArray;
                };


                //---------------------------------------------------------------------------------------
                //  Redraw Legend
                //---------------------------------------------------------------------------------------       
                $scope.drawLegend = function (position, colourScale, data) {

                    $scope.svg.selectAll(".legend").remove();

                    var legend = $scope.svg.append("g")
                        .attr("class", "legend")
                        .attr("transform", "translate(" + position.x + ", " + (position.y + 20) + ")");

                    var legendTitle = legend
                        .append("text")
                        //.attr("x", 9)
                        //.attr("y", 5)
                        //.attr("dy", ".1em")
                        .style("font-size", ".65em")
                        .style("text-anchor", "start")
                        .style("font-weight", "bold")
                        .text("Current Stage");

                    colourScale.domain().forEach(function (key, i) {
                        var legendRow = legend.append("g")
                            .attr("transform", "translate(0," + Math.abs((i) * 15 + 10) + ")");

                        legendRow
                            .append("rect")
                            .attr("width", 7)
                            .attr("height", 7)
                            .style("fill", colourScale(key));


                        legendRow
                            .append("text")
                            .attr("x", 9)
                            .attr("y", 5)
                            .attr("dy", ".1em")
                            .style("font-size", ".6em")
                            .style("text-anchor", "start")
                            .text(data[key].label);
                    });

                };
                //  /Redraw Legend ----------------------------------------------------------------------


                //---------------------------------------------------------------------------------------
                //  Redraw Chart
                //---------------------------------------------------------------------------------------
                $scope.redrawChart = function (chartData) {
                    // Format incomming data ---------------------------------------------
                    var associativeArray = buildAssociativeArray(chartData.startupYears);
                    var categories = Object.keys(associativeArray);

                    chartData.startupYears.forEach(function (year) {

                        // take a copy of the associative array
                        var yearAssociativeArray = Object.assign({}, associativeArray);

                        // populate the associative array with data
                        if (year.projectStages) {
                            year.projectStages.forEach(function (item) {
                                var key = item.projectStage.replace(" ", "").replace("-", "");
                                yearAssociativeArray[key] = item.value;
                            });
                        }
                        // Format incomming data ---------------------------------------------

                        // compute the bar intervals ---------------------------------------------
                        var y0 = 0;
                        year.projectStageIntervals = categories.map(function (key) {
                            return {
                                key: key,
                                y0: y0,
                                y1: y0 += +yearAssociativeArray[key],
                                startupYear: year.startupYear

                            };
                        });
                        year.total = year.projectStageIntervals[year.projectStageIntervals.length - 1].y1;
                    });
                    // compute the bar intervals ---------------------------------------------


                    // set up colour scale ---------------------------------------------
                    $scope.color.range(categories.map(function (item) {
                        return projectStages[item].colour;
                    }));
                    $scope.color.domain(categories.map(function (item) {
                        return item;
                    }));
                    // set up colour scale ---------------------------------------------

                    // refresh Titles and Axes ---------------------------------------------
                    captions = $scope.options.captions;

                    $scope.svg.select(".titleCountry")
                        .text(chartData.countryName);

                    $scope.svg.select(".titleMain")
                        .text(chartData.sector + captions.title);

                    $scope.svg.selectAll(".axisLabel").filter(".x")
                        .text(captions.axes.x);

                    $scope.svg.selectAll(".axisLabel").filter(".y")
                        .text(captions.axes.y);


                    $scope.xScale.domain(chartData.startupYears.map(function (d) { return d.startupYear; }));
                    $scope.xAxis.transition().call($scope.xAxisGen);

                    $scope.yScale.domain([0, d3.max(chartData.startupYears, function (d) { return d.total; })]);
                    $scope.yAxis.transition().call($scope.yAxisGen);
                    // refresh Titles and Axes ---------------------------------------------


                    // D3 Chart Update Cycle ---------------------------------------------

                    var years = $scope.chartFrame.selectAll(".year")
                        .data(chartData.startupYears);

                    years.exit()
                        .attr("y", 0)
                        .style('height', 0)
                        .style('width', 0)
                        .style('opacity', 0.001)
                        .remove();

                    // recalculate the positions of the columns
                    years
                        .enter().append("g")
                        .attr("class", "year")
                        .attr("transform",
                            function (d) {
                                return "translate(" + $scope.xScale(d.startupYear) + ",0)";
                            });

                    years
                        .attr("transform",
                            function (d) {
                                return "translate(" + $scope.xScale(d.startupYear) + ",0)";
                            });


                    // set up the barData
                    var bars = years.selectAll(".bar")
                        .data(function (d) {
                            return d.projectStageIntervals;
                        });

                    // items to remove
                    bars.exit()
                        .transition()
                        .attr('y', $scope.yScale(0))
                        .style('height', 0)
                        .style('opacity', 0.001)
                        .remove();

                    // items to  update (recalculate widths as well as heights)
                    bars
                        .transition()
                        .attr("width", $scope.xScale.rangeBand())
                        .attr("y", function (d) { return $scope.yScale(d.y1); })
                        .attr("height", function (d) { return $scope.yScale(d.y0) - $scope.yScale(d.y1); })
                        .style("fill",
                            function (d) {

                                return $scope.color(d.key);
                            });

                    // Define the div for the tooltip
                    var tooltip = d3.select("body").append("div")
                        .attr("class", "tooltip")
                        .style("opacity", 0);

                    var formatThousands = d3.format(", ");
                    var composeTooltip = function (d) {
                        var tooltip = captions.tooltipTemplate
                            .replace("<~startupYear~>", d.startupYear)
                            .replace("<~key~>", d.key)
                            .replace("<~value~>", formatThousands(d.y1 - d.y0));

                        return tooltip;
                    };

                    // items to add
                    // a click event callback allows us to filter the project list
                    // based on the year and project tage
                    bars
                        .enter().append("rect")
                        .on('click', $scope.onBarClicked)
                        .on("mouseover", function (d) {
                            tooltip.transition()
                                .duration(200)
                                .style("opacity", .9);
                            tooltip.html(composeTooltip(d))
                                .style("left", (d3.event.pageX) + "px")
                                .style("top", (d3.event.pageY - 28) + "px");
                        })
                        .on("mouseout", function (d) {
                            tooltip.transition()
                                .duration(500)
                                .style("opacity", 0);
                        })
                        .transition()
                        .attr("class", function (d, i) { return "bar b" + i; })
                        .attr("width", $scope.xScale.rangeBand())
                        .attr("y", function (d) { return $scope.yScale(d.y1); })
                        .attr("height", function (d) { return $scope.yScale(d.y0) - $scope.yScale(d.y1); })

                        .style("fill",
                            function (d) {
                                return $scope.color(d.key);
                            });

                    // D3 Chart Update Cycle ---------------------------------------------



                };
                // /Redraw Chart -------------------------------------------------------------------------

                $scope.$onInit();
                console.log("GeographicalSummaryChartController:initialised");

            }
        ]
    )
    .directive('geographicalSummaryChart', function () {
        return {
            // bindings:
            restrict: 'E',
            //replace: true,
            // bindings: {
            //     energySectors: '<',
            //     countrySelected: '<',
            //     chartData: '<', // this is  promise 
            //     chartType: "<",
            //     options: "<",
            //     isVisible: "<",
            //     onBarClicked: "<"
            // },
            scope: {
                energySectors: '=',
                countrySelected: '=',
                chartData: '=', // this is  promise 
                chartType: "=",
                options: "=",
                isVisible: "=",
                onBarClicked: "="
            },
            template: "\
<div class='svg-container'  ng-show='isVisible'>\
      <svg version='1.1' viewBox='0 0 300 400' preserveAspectRatio='xMinYMin meet' class='svg-content canvas'></svg>\
</div>\
",
            controller: "GeographicalSummaryChartController"
        }
    });

